const { client } = require('../../MbaasClient')

export const funcGetOneTransactions = async (resource, params) => {
  let initTable = client
    .getTable(resource)
    .include(['customers', 'users', 'organizations', 'products', 'reference_snapshots'])
  const { data } = await initTable.lookup(params.id)
  return { data }
}
